import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, Download, FileSpreadsheet } from "lucide-react";

export function PIPreviewDialog({ url, onClose, onConfirm, onDownload, busy, isSaved }) {
  return (
    <Dialog open={!!url} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-5xl h-[92vh] flex flex-col p-0 gap-0" data-testid="pi-preview-dialog">
        <DialogHeader className="px-6 pt-5 pb-3">
          <DialogTitle>Preview: proforma invoice</DialogTitle>
          <DialogDescription>Check the PDF below. It is marked DRAFT, and nothing is saved or numbered until you confirm.</DialogDescription>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-y-auto bg-slate-100 px-6 py-4 space-y-4" data-testid="pi-preview-pages">
          {(url || []).map((src, i) => (
            <img key={i} src={src} alt={`PI preview page ${i + 1}`} className="mx-auto w-full max-w-3xl bg-white shadow-md ring-1 ring-slate-200" data-testid={`pi-preview-page-${i + 1}`} />
          ))}
        </div>
        <DialogFooter className="px-6 py-4 border-t border-slate-100">
          <Button variant="outline" onClick={onClose} data-testid="pi-preview-back">Back to edit</Button>
          <Button variant="outline" onClick={() => onDownload("pdf")} data-testid="pi-preview-download"><Download className="h-4 w-4 mr-1" />Draft PDF</Button>
          <Button variant="outline" onClick={() => onDownload("xlsx")} data-testid="pi-preview-download-xlsx"><FileSpreadsheet className="h-4 w-4 mr-1" />Draft XLS</Button>
          <Button onClick={onConfirm} disabled={busy} className="bg-sky-700 hover:bg-sky-800" data-testid="pi-preview-confirm">
            {busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <CheckCircle2 className="h-4 w-4 mr-1" />}
            {isSaved ? "Confirm & save changes" : "Confirm & generate PI"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
